module.exports = __webpack_public_path__ + "static/media/parent-testimonial.8c681b4a.png";